var _rect, _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStackHeaderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 106,
    viewBox: "0 0 153 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 124.044,
    y: 23.3824,
    width: 39.75,
    height: 39.75,
    rx: 19.875,
    transform: "rotate(90 124.044 23.3824)",
    fill: "#F2E9FB"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.0512,
    cy: 82.2279,
    rx: 3.50735,
    ry: 3.50735,
    transform: "rotate(90 48.0512 82.2279)",
    fill: "#00FFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.3363 14.4261C40.6866 14.5545 40.6865 15.0629 40.3362 15.1911C35.7568 16.8675 34.132 18.4918 32.4559 23.0712C32.3277 23.4215 31.8192 23.4216 31.6909 23.0714C30.0135 18.4937 28.3901 16.8694 23.811 15.1915C23.4607 15.0632 23.4608 14.5547 23.8111 14.4265C28.3905 12.7502 30.0153 11.1259 31.6914 6.54643C31.8196 6.19612 32.328 6.19601 32.4564 6.54628C34.1338 11.124 35.7572 12.7482 40.3363 14.4261Z",
    fill: "url(#paint0_linear_26951_20782)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2497 55.3382C97.8721 55.3382 107.294 51.1508 107.294 45.9853C107.294 40.8198 97.8721 36.6324 86.2497 36.6324C74.6273 36.6324 65.2056 40.8198 65.2056 45.9853C65.2056 51.1508 74.6273 55.3382 86.2497 55.3382Z",
    stroke: "url(#paint1_linear_26951_20782)",
    strokeWidth: 1.55882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2056 45.9853V74.0441C65.2056 79.1882 74.5585 83.3971 86.2497 83.3971C97.9409 83.3971 107.294 79.1882 107.294 74.0441V45.9853",
    stroke: "url(#paint2_linear_26951_20782)",
    strokeWidth: 1.55882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.294 60.0147C107.294 65.1588 97.9409 69.3677 86.2497 69.3677C74.5585 69.3677 65.2056 65.1588 65.2056 60.0147",
    stroke: "url(#paint3_linear_26951_20782)",
    strokeWidth: 1.55882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7824 27.3205C80.3179 23.9481 73.9571 22.3172 67.5441 22.644C55.8997 22.644 46.5 26.8528 46.5 31.9969C46.5 34.7561 49.2124 37.2346 53.5147 39.0116",
    stroke: "url(#paint4_linear_26951_20782)",
    strokeWidth: 1.55882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5147 67.0706C49.2124 65.2935 46.5 62.8149 46.5 60.0558V31.997",
    stroke: "url(#paint5_linear_26951_20782)",
    strokeWidth: 1.55882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5147 53.0411C49.2124 51.264 46.5 48.7855 46.5 46.0264",
    stroke: "url(#paint6_linear_26951_20782)",
    strokeWidth: 1.55882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26951_20782",
    x1: 41.214,
    y1: 14.6555,
    x2: 10.6643,
    y2: 24.9381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26951_20782",
    x1: 106.816,
    y1: 45.832,
    x2: 58.1837,
    y2: 82.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26951_20782",
    x1: 106.816,
    y1: 64.3845,
    x2: 39.8879,
    y2: 89.7274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26951_20782",
    x1: 106.816,
    y1: 64.6145,
    x2: 83.5852,
    y2: 99.8002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_26951_20782",
    x1: 85.336,
    y1: 30.6728,
    x2: 42.0312,
    y2: 65.5673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_26951_20782",
    x1: 53.435,
    y1: 49.2463,
    x2: 40.7385,
    y2: 50.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_26951_20782",
    x1: 53.435,
    y1: 49.4763,
    x2: 41.9789,
    y2: 53.3322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackHeaderIcon);
export default __webpack_public_path__ + "static/media/stack-header-icon.b0ccc78de42d19c877f6aa24b0b4ad31.svg";
export { ForwardRef as ReactComponent };